/* eslint-disable @typescript-eslint/no-explicit-any */
import { KDataLake } from './k-datalake';
import { PpfDataLake } from './ppf-datalake';

export const pluginsMap = {
  [KDataLake.pluginName]: (config: any) => new KDataLake(config),
  [PpfDataLake.pluginName]: (config: any) => new PpfDataLake(config),
};
